/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMoeMarketingScriptsViewProps } from './moe-marketing-scripts';

export default (props: IMoeMarketingScriptsViewProps) => {
    return (
        <>
            <div id={props.config.script_id} />
            <script src={props.config.script} defer />
            <div
                className='d365-mkt-config'
                style={{ display: 'none' }}
                data-website-id={props.config.website_id}
                data-hostname={props.config.hostname}
            />
        </>
    );
};
